import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {CategoryPref} from '../constants';

export const shouldEnforceAlphabetical = () =>
	getPreference(CategoryPref.KEEP_ALPHABETICAL, true);

export default shouldEnforceAlphabetical;
